<app-sidebar></app-sidebar>

<div
  class="main-content d-flex flex-column"
  [ngClass]="{mobileView: topNavigation == 'mobileView', desktopView: topNavigation == 'desktopView'}">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <div class="flex-grow-1"></div>
</div>
